
import { useEffect, useState } from "react";

import { useDispatch } from "react-redux";

import { useNavigate } from "react-router";

import { Button, CircularProgress, Dialog, DialogActions, DialogContent, FormControl, Grid, IconButton, InputLabel, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, TextField, Typography } from "@mui/material"

import UndoIcon from "@mui/icons-material/Undo";
import EditIcon from "@mui/icons-material/Edit";

import { TablePaginationActions } from "../../helpers/TablePaginationActions";

import { usePages } from "../../hooks/usePages";
import { useFilter } from "../../hooks/useFilter";

import { openSnackbar } from "../../store/slices/SnackbarSlice";

import { TablePaddingStyle, TableTheadStyle } from "../../styles/TableStyle";

import { Layout } from "../../components/Layout"
import { SearchTextField } from "../../components/SearchTextField";

import { ActualizarConsecutivo, AgregarConsecutivo, Consecutivo } from "../../connections/admin/ConsecutivoConnection";
import { TipoConsecutivos } from "../../connections/catalogos/TipoConsecutivoConnection";
import { Autoridades } from "../../connections/catalogos/AutoridadConnection";

import { ConsecutivoProps } from "../../interfaces/admin/ConsecutivoInterface";
import { TipoConsecutivoProps } from "../../interfaces/catalogos/TipoConsecutivoInterface";
import { AutoridadProps } from "../../interfaces/catalogos/AutoridadInterface";

export const ConsecutivoPage = () => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const [idConsecutivo, setIdConsecutivo] = useState( 0 );

    const [numeroConsecutivo, setNumeroConsecutivo] = useState( 1 );
    const [anio, setAnio] = useState( new Date().getFullYear() );

    const [tipoConsecutivo, setTipoConsecutivo] = useState( 0 );
    const [tipoConsecutivoArray, setTipoConsecutivoArray] = useState<TipoConsecutivoProps[]>( [] );

    const [autoridad, setAutoridad] = useState( 0 );
    const [autoridadArray, setAutoridadArray] = useState<AutoridadProps[]>( [] );

    const [rows, setRows] = useState<ConsecutivoProps[]>( [] );

    const [openDialog, setOpenDialog] = useState( false );

    const [loading, setLoading] = useState( false );
    const [loadingGuardar, setLoadingGuardar] = useState( false );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages( 10 );

    const { filtro, setFiltro, dataFiltrada } = useFilter( rows, ( item, filtro ) =>
        ( item.tipoConsecutivo?.descripcion?.toLowerCase().includes( filtro.toLowerCase() ) ?? false ) ||
        ( item.autoridad?.descripcion?.toLowerCase().includes( filtro.toLowerCase() ) ?? false )
    );

    const handleGuardar = async() => {

        if ( idConsecutivo !== 0 ) {

            var consecutivo = rows.find( (e) => e.idConsecutivo === idConsecutivo );

            if ( consecutivo ) {

                setLoadingGuardar( true );

                await ActualizarConsecutivo({ ...consecutivo, numeroConsecutivo, anio, idTipoConsecutivo: tipoConsecutivo, idAutoridad: autoridad, }).then( resp => {

                    if ( resp.idConsecutivo !== 0 ) {

                        setTimeout(() => {

                            const newArray = rows.map( ( elem ) => {
                                if ( elem.idConsecutivo === idConsecutivo ) {
                                    elem.numeroConsecutivo = numeroConsecutivo;
                                    elem.anio = anio;
                                    elem.idTipoConsecutivo = tipoConsecutivo;
                                    elem.tipoConsecutivo = resp.tipoConsecutivo;
                                    elem.idAutoridad = autoridad;
                                    elem.autoridad = resp.autoridad;
                                }
                                return elem;
                            });

                            setRows( newArray );
                            setOpenDialog( false );
                            setLoadingGuardar( false );

                            dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' }));

                        }, 700);

                    }

                });

            }

        }
        else {

            const consecutivoAdd : ConsecutivoProps = {
                idConsecutivo: 0,
                numeroConsecutivo,
                anio,
                idTipoConsecutivo: tipoConsecutivo,
                idAutoridad: autoridad,
            };

            setLoadingGuardar( true );

            await AgregarConsecutivo( consecutivoAdd ).then( resp => {

                if ( resp.idConsecutivo !== 0 ) {

                    setTimeout(() => {

                        setRows([ ...rows, resp ]);
                        setOpenDialog( false );
                        setLoadingGuardar( false );

                        dispatch( openSnackbar({ message: 'Se agregó el consecutivo correctamente', variant: 'success' }));

                    }, 700);
                }

            });

        }

    }

    useEffect(() => {

        async function Obtener(){

            setRows( [] );
            setLoading( true );

            await Consecutivo().then( resp => {

                setTimeout(() => {

                    setRows( resp );
                    setLoading( false );

                }, 700);

            });

        }

        Obtener();

    }, [ ])

    useEffect(() => {

        async function Obtener(){
            await TipoConsecutivos().then( resp => {
                setTipoConsecutivoArray( resp );
            });

        }

        Obtener();

    }, [ ])

    useEffect(() => {

        async function Obtener(){
            await Autoridades().then( resp => {
                setAutoridadArray( resp );
            });

        }

        Obtener();

    }, [ ])

    return (

        <Layout breadcrumbs={ [ { text: 'Administración' }, { text: 'Consecutivo' } ] } backgroundPaper={ false }>

            <Grid container spacing={ 3 }>

                <Grid size={{ xs: 6 }} textAlign={ 'start' }>

                    <Button color="secondary" variant="text" sx={{ mt: 1 }} startIcon={ <UndoIcon /> } onClick={ () => navigate('/') }>
                        Regresar
                    </Button>

                </Grid>

                <Grid size={{ xs: 6 }} textAlign={ 'end' } sx={{ mt: 1 }}>

                    <Button
                        variant="contained"
                        onClick={ () => {
                            setIdConsecutivo( 0 );
                            setNumeroConsecutivo(1);
                            setAnio( new Date().getFullYear() );
                            setTipoConsecutivo( 0  );
                            setAutoridad( 0 );
                            setOpenDialog( true );
                        }}
                    >
                        Agregar
                    </Button>

                </Grid>

            </Grid>

            <Grid container sx={{ mt: 2 }}>
                <Grid size={{ xs: 12 }}>
                    <SearchTextField
                        value={ filtro }
                        label="Buscar por tipo de consecutivo o autoridad"
                        onChange={ ( value ) => {
                            setFiltro( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />
                </Grid>
            </Grid>

            <TableContainer sx={{ mt: 3, borderRadius: 3 }} component={ Paper }>

                <Table sx={{ minWidth: 500 }}>

                    <TableHead sx={{ ...TableTheadStyle }}>

                        <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                            <TableCell sx={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', textAlign: 'center' }}>Id</TableCell>
                            <TableCell sx={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', textAlign: 'center' }}>Numero de consecutivo</TableCell>
                            <TableCell sx={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', textAlign: 'center' }}>Anio</TableCell>
                            <TableCell sx={{ ...TablePaddingStyle, ...TableTheadStyle, width: '20%' }}>Tipo de consecutivo</TableCell>
                            <TableCell sx={{ ...TablePaddingStyle, ...TableTheadStyle, width: '30%', textAlign: 'center' }}>Autoridad</TableCell>
                            <TableCell sx={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%' }}></TableCell>

                        </TableRow>

                    </TableHead>

                    <TableBody>

                        {
                            (
                                rowsPerPage > 0
                                ?
                                    dataFiltrada.slice( page * rowsPerPage, page * rowsPerPage + rowsPerPage )
                                :
                                    dataFiltrada
                            )
                            .map( ({ idConsecutivo, numeroConsecutivo, anio, idTipoConsecutivo, tipoConsecutivo, idAutoridad, autoridad }) => (

                                <TableRow key={ idConsecutivo }>

                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>{ idConsecutivo }</TableCell>

                                    <TableCell sx={{ textAlign: 'center' }}>{ numeroConsecutivo }</TableCell>

                                    <TableCell sx={{ textAlign: 'center' }}>{ anio }</TableCell>

                                    <TableCell>{ tipoConsecutivo?.descripcion }</TableCell>

                                    <TableCell>{ autoridad?.descripcion }</TableCell>

                                    <TableCell sx={{ textAlign: 'end' }}>

                                        <IconButton
                                            color="primary"
                                            onClick={ () => {
                                                setIdConsecutivo( idConsecutivo );
                                                setNumeroConsecutivo( numeroConsecutivo );
                                                setAnio( anio );
                                                setTipoConsecutivo( idTipoConsecutivo );
                                                setAutoridad( idAutoridad ?? 0 );
                                                setOpenDialog( true );
                                            }}
                                        >
                                            <EditIcon />
                                        </IconButton>

                                    </TableCell>

                                </TableRow>

                            ))
                        }

                        {
                            ( dataFiltrada.length === 0 && !loading )
                            ?
                                <TableRow sx={{ height: 93 }}>

                                    <TableCell colSpan={ 8 } align="center">

                                        <Typography variant="caption" color="secondary">No se encontraron resultados</Typography>

                                    </TableCell>

                                </TableRow>
                            :
                                loading
                                &&
                                    <TableRow sx={{ height: 93 }}>

                                        <TableCell colSpan={ 8 } align="center">

                                            <CircularProgress size={ 32 } />

                                        </TableCell>

                                    </TableRow>
                        }

                    </TableBody>

                    <TableFooter>

                        <TableRow>

                            <TableCell colSpan={ 2 } sx={{ border: 'none' }}>
                                <Typography variant='body2' color='black' fontWeight={ 'bold' }>Total de registros: { dataFiltrada.length }</Typography>
                            </TableCell>

                            <TablePagination
                                colSpan={ 8 }
                                page={ page }
                                rowsPerPage={ rowsPerPage }
                                count={ dataFiltrada.length }
                                onPageChange={ handleChangePage }
                                onRowsPerPageChange={ handleChangeRowsPerPage }
                                ActionsComponent={ TablePaginationActions }
                                sx={{ border: 'none' }}
                                rowsPerPageOptions={ [ 5, 10, 15, 25, 50, 75, 100, 150, 200, 500 ] }
                                labelRowsPerPage={ 'Filas por página' }
                                labelDisplayedRows={ ({ from, to, count }) => `${ from }-${ to } de ${ count }` }
                            />

                        </TableRow>

                    </TableFooter>

                </Table>

            </TableContainer>

            <Dialog
                maxWidth='sm'
                fullWidth
                open={ openDialog }
            >

                <DialogContent>

                    <Grid container spacing={ 3 } sx={{ mt: 2 }}  >

                        <Grid size={ 12 } >

                            <FormControl fullWidth >
                                <InputLabel sx={{ fontSize: 16 }}>Autoridad</InputLabel>

                                <Select
                                    label={ 'Autoridad' }
                                    value={ autoridad }
                                    onChange={ (e) => setAutoridad( e.target.value ?? 0 ) }
                                >
                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                    {
                                        autoridadArray.map((elem) => (
                                            <MenuItem key={ elem.idAutoridad } value={ elem.idAutoridad }> {elem.descripcion} </MenuItem>
                                        ))
                                    }
                                </Select>

                            </FormControl>

                        </Grid>

                        <Grid size={ 12 } >

                            <FormControl fullWidth >
                                <InputLabel sx={{ fontSize: 16 }}>Tipo de consecutivo</InputLabel>

                                <Select
                                    label={ 'Tipo de consecutivo' }
                                    value={ tipoConsecutivo }
                                    onChange={ (e) => setTipoConsecutivo( e.target.value ?? 0 ) }
                                >
                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                    {
                                        tipoConsecutivoArray.map((elem) => (
                                            <MenuItem key={ elem.idTipoConsecutivo } value={ elem.idTipoConsecutivo }> {elem.descripcion} </MenuItem>
                                        ))
                                    }
                                </Select>

                            </FormControl>

                        </Grid>

                        <Grid size={ 6 } >

                            <TextField
                                fullWidth
                                label={ 'Número de consecutivo' }
                                slotProps={{
                                    input: {
                                        autoComplete: 'off'
                                    },
                                    inputLabel: {
                                        shrink: true,
                                    }
                                }}
                                value={ numeroConsecutivo }
                                onChange={ (e) => setNumeroConsecutivo( parseInt( e.target.value.toString() ?? '0' ) ) }
                            />

                        </Grid>

                        <Grid size={ 6 } >

                            <TextField
                                fullWidth
                                label={ 'Año' }
                                slotProps={{
                                    input: {
                                        autoComplete: 'off'
                                    },
                                    inputLabel: {
                                        shrink: true,
                                    }
                                }}
                                value={ anio }
                                onChange={ (e) => setAnio( parseInt( e.target.value.toString() ?? '0' ) ) }
                            />

                        </Grid>

                    </Grid>

                </DialogContent>

                <DialogActions>

                    <Button color="secondary" variant="text" disabled={ loadingGuardar } onClick={ () => setOpenDialog( false ) }>Cancelar</Button>
                    <Button variant="contained" disabled={ numeroConsecutivo === 0 || anio.toString().length !== 4 || tipoConsecutivo === 0 } loading={ loadingGuardar } onClick={ handleGuardar }>Guardar</Button>

                </DialogActions>

            </Dialog>

        </Layout>

    )
}
